export default __webpack_public_path__ + "img/owl-wing-open.2f721587.svg";